import { IUapiReferral } from "../contracts/Onboarding";
import {
  IUapiAttachRequest,
  IUapiAttachResponse,
  IUapiAuthStatusRequest,
  IUapiAuthStatusResponse,
  IUapiFormRequest,
  IUapiFormResponse,
  IUapiManualSaveRequest,
  IUapiManualSaveResponse,
  IUapiReferralData,
  IUapiReferralRequest,
  IUapiReferralResponse,
  IUapiWebhookRequest,
  IUapiWebhookResponse,
} from "../contracts/Uapi";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IUapi } from "./interfaces/IUapi";

const API_BASE_URL = `/Uapi`;

export const Uapi: IUapi = {
  // Referral methods
  saveUapiReferral: async (
    request: IUapiReferralRequest
  ): Promise<IZeosApiResponse<IUapiReferralResponse>> => {
    const response = await postDataAsync<IUapiReferralResponse>(
      `${API_BASE_URL}/referral`,
      request
    );
    return response;
  },

  getReferralData: async (
    zeosUserId: string
  ): Promise<IZeosApiResponse<IUapiReferralData>> => {
    const response = await getDataAsync<IUapiReferralData>(
      `${API_BASE_URL}/referral/${zeosUserId}`,
      ""
    );
    return response;
  },

  // Legacy Methods (for backward compatibility)
  postReferralCodeLEGACY: async (
    zeosUserId: string,
    referralCode: string
  ): Promise<IZeosApiResponse<null>> => {
    return await postDataAsync<null>(`${API_BASE_URL}/referral`, {
      zeosUserId,
      referralCode,
    });
  },

  getReferralDataLEGACY: async (
    uapiAccountId: string
  ): Promise<IZeosApiResponse<IUapiReferral>> => {
    const query = `?zeosUserId=${encodeURIComponent(uapiAccountId)}`;
    return await getDataAsync<IUapiReferral>(
      `${API_BASE_URL}/referral${query}`,
      ""
    );
  },

  // Manual data methods
  saveUapiManual: async (
    propertyId: number,
    request: IUapiManualSaveRequest
  ): Promise<IZeosApiResponse<IUapiManualSaveResponse>> => {
    const response = await postDataAsync<IUapiManualSaveResponse>(
      `${API_BASE_URL}/manual/${propertyId}`,
      request
    );
    return response;
  },

  // Form methods
  createForm: async (
    request: IUapiFormRequest
  ): Promise<IZeosApiResponse<IUapiFormResponse>> => {
    const response = await postDataAsync<IUapiFormResponse>(
      `${API_BASE_URL}/form`,
      request
    );
    return response;
  },

  // Auth status methods
  getAuthStatus: async (
    request: IUapiAuthStatusRequest
  ): Promise<IZeosApiResponse<IUapiAuthStatusResponse>> => {
    const query = `?formUid=${encodeURIComponent(request.formUid)}`;
    const response = await getDataAsync<IUapiAuthStatusResponse>(
      `${API_BASE_URL}/auth-status${query}`,
      ""
    );
    return response;
  },

  attachAuthorization: async (
    request: IUapiAttachRequest
  ): Promise<IZeosApiResponse<IUapiAttachResponse>> => {
    const response = await postDataAsync<IUapiAttachResponse>(
      `${API_BASE_URL}/attach-authorization`,
      request
    );
    return response;
  },

  // Webhook methods
  processWebhook: async (
    request: IUapiWebhookRequest
  ): Promise<IZeosApiResponse<IUapiWebhookResponse>> => {
    const response = await postDataAsync<IUapiWebhookResponse>(
      `${API_BASE_URL}/webhook`,
      request
    );
    return response;
  },
};
